import axios from 'axios'

interface CatchErrorProps {
  message: string
}

export function catchError(error: unknown): CatchErrorProps {
  if (axios.isAxiosError(error)) {
    if (error.response?.status === 401) {
      return { message: 'Usuário não autenticado' }
    }
    if (error.response?.status === 403) {
      return { message: 'Sem permissão para o acesso.' }
    }
    if (error.response?.status === 404) {
      return { message: 'Página não encontrada' }
    }
    if (error.message === 'cancelToken') {
      return { message: 'cancelToken' }
    }
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
